import React, { useCallback } from "react";
import { Grid } from "semantic-ui-react";
import InputField from "@commonComponents/formComponents/CustomInputField";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import DeleteIcon from "@commonComponents/deleteIcon";

const AdditionalDocForm = (props) => {
  const {
    dataSource: {
      id,
      type,
      identification
    },
    translate,
    isDisabled,
    copyDocument,
    deleteData,
    onChange,
    onSelect,
    onBlur,
    tableName,
    docTypeList,
    additionalDocValidarion,
    addDocIdx,
    markedDeleted,
    isAdditionalDocDisabled
  } = props
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange, translate]) 
  const onDropDownChange = useCallback(
    (e, {value, name}) => {
      const params = {}
       if(additionalDocValidarion) additionalDocValidarion(addDocIdx,name,value)
      if (name == 'type')
        params.description = docTypeList?.find((c) => c.value == value)?.additionalInfo
      onSelect(id, tableName, { [name]: value, id, ...params })
    },
    [tableName, id, onSelect, docTypeList,translate]
  )
  const onBlurHandler=useCallback(({target:{value,name}})=>{
    if(additionalDocValidarion) additionalDocValidarion(addDocIdx,name,value)
    onBlur(tableName,{[name]:value,id})
  },[tableName,id,onBlur,translate])
  
  return (
    <div className="formContainer">
      <div className="actionbtns">
        {copyDocument && copyDocument(translate)}
      </div> 
    <Grid.Row>
      <Grid.Column>
        <DropDown
          id={`type-${id}`}
          label="ADDL_DOC_CODE"
          labelClass="text-none"
          name="type"
          data={docTypeList}
          clearable
          value={type}
          text={type}
          onChange={onDropDownChange}
          isDisabled={isAdditionalDocDisabled||isDisabled}
        />
      </Grid.Column>
      <Grid.Column>
        <InputField
          id={`identification-${id}`}
          name="identification"
          type="text"
          label="ADDL_DOCUMENT_STATEMENT_IDENTIFICATION"
          value={identification}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          isDisabled={isAdditionalDocDisabled||isDisabled}
        />
      </Grid.Column>
    </Grid.Row>
    <div className="actionbtns">
      {markedDeleted?markedDeleted({id, tableName}):
       <DeleteIcon isDisabled={isDisabled} onClick={()=>deleteData(id,tableName)} />}
    </div>
    </div>
  );
}
AdditionalDocForm.defaultProps = {
    translate:(value)=>value
  }
export default React.memo(AdditionalDocForm)
